module.exports = __webpack_public_path__ + "img/logo_cost_sub.236b8ae1.png";